import axios from 'axios'
import React, {useEffect, useState} from 'react'
import {ChangePasswordForm} from '../../components/ChangePasswordForm/ChangePasswordForm'
import './Perfil.css'

type AdminProfile = {nombre: string; apellido: string; email: string; rol: string; estatus: string}

function Perfil() {
  const API_URL = process.env.REACT_APP_API_URL
  const [profile, setProfile] = useState<AdminProfile | null>(null)
  const [loading, setLoading] = useState(true)
  const [loadError, setLoadError] = useState('')

  useEffect(() => {
    axios.get(`${API_URL}/perfil-admin`)
      .then(({data}) => setProfile(data.data))
      .catch((error) => {
        console.error('No fue posible cargar el perfil administrativo.', error)
        setLoadError(error.response?.data?.message || 'No fue posible cargar tu perfil.')
      })
      .finally(() => setLoading(false))
  }, [API_URL])

  const profileFields: Array<[string, string | undefined]> = [
    ['Nombre', profile?.nombre], ['Apellido', profile?.apellido],
    ['Correo electrónico', profile?.email], ['Rol', profile?.rol], ['Estatus', profile?.estatus],
  ]

  return <div className='perfil-admin'>
    {loading && <section className='perfil-admin-loading'>Cargando perfil...</section>}
    {!loading && <>
      <header><h1>Mi Perfil</h1><p>Consulta la información de tu cuenta interna.</p></header>
      {loadError && <div className='alert alert-danger' role='status'>{loadError}</div>}
      <section>
        <h2>Información general</h2>
        <div className='perfil-admin-info-grid'>{profileFields.map(([label, value]) => <div className='perfil-admin-field' key={label}><span>{label}</span><strong>{value || 'No disponible'}</strong></div>)}</div>
      </section>
      <section>
        <h2>Cambiar contraseña</h2>
        <p className='perfil-admin-section-description'>Por seguridad, confirma primero tu contraseña actual.</p>
        <ChangePasswordForm endpoint='perfil-admin-password' />
      </section>
    </>}
  </div>
}

export {Perfil}
